import React, { useEffect, useState } from "react";
import customerDetailsStyles from "assets/jss/material-kit-pro-react/views/cspDashboard/customerDetailsStyles.js";
import style from "assets/jss/material-kit-pro-react/views/componentsSections/contentAreas.js";
import headersStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/headersStyle.js";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core";
import { Card as CoreCard, CardContent } from "@material-ui/core";
import get, { post } from "lib/requests";
import { ErrorMessage } from "components/Common/toastify";
import CustomInput from "../../../../components/CustomInput/CustomInput.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import classNames from "classnames";
import Loading from "components/Common/loading";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import Table from "components/Table/Table.js";
import Cart from "./Cart.js";
import { LoadingMgs } from "components/Common/toastify.jsx";
import { SuccessMessage } from "components/Common/toastify.jsx";
import { setCart } from "redux/ducks/cartSlice.js";
import { setDashboard } from "redux/ducks/CSPDashboardSlice.js";
import { Add } from "@material-ui/icons";

const useStyles3 = makeStyles({
	card: {
		cursor: "pointer",
		padding: "5px !important",
		paddingLeft: "10px !important",
		paddingRight: "10px !important",
		marginBottom: "10px !important",
		// marginTop: "10px !important",
		margin: "0px !important",
	},
	content: {
		padding: "0px !important",
		margin: "0px !important",
	},
	text: {
		fontSize: "14px",
		fontWeight: 500,
	},
});
const useStyles2 = makeStyles(headersStyle);

const useStyles = makeStyles(style);
const useStylesCustomerDetailsStyles = makeStyles(customerDetailsStyles);

const SubscriptionAdd = () => {
	const classes2 = useStyles2();
	const classesCSStyles = useStylesCustomerDetailsStyles();

	const [loading, setLoading] = useState(false);
	const [popularLoading, setPopularLoading] = useState(false);
	const [recentLoading, setRecentLoading] = useState(false);
	const [products, setProducts] = useState([]);
	const [popularProducts, setPopularProducts] = useState([]);
	const [popularOriginalData, setPopularOriginalData] = useState([]);
	const [originalData, setOriginalData] = useState([]);
	const [searchText, setSearchText] = useState("");
	const classes = useStyles();
	const customerDetails = useSelector((state) => state.customer);
	const dispatch = useDispatch();
	const classes3 = useStyles3();
	const [recentProducts, setRecentProducts] = useState([]);
	const [recentOriginalData, setRecentOriginalData] = useState([]);

	useEffect(() => {
		window.scrollTo(0, 0);
		document.body.scrollTop = 0;
		if (!customerDetails?.tenantId) {
			ErrorMessage("Products", "Please select customer");
			cancelOrder();
			return;
		}

		getPopularProducts();
		getProductsList();
		getRecentProducts();
		return function cleanup() {};
	}, []);

	const getProductsList = async () => {
		setLoading(true);
		try {
			await get(`/api/productlist/${customerDetails?.tenantId}`, true)
				.then((res) => {
					if (res.data.success) {
						setProducts(res.data.records);
						setOriginalData(res.data.records);
					} else {
						const errorMsg =
							res.data.errors?.map((error) => error).join(", ") || res.data.message;
						ErrorMessage("Products", errorMsg);
					}
					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("Products", message);
					setLoading(false);
				});
		} catch (error) {
			ErrorMessage("Products", "Something went wrong try again!!");
			setLoading(false);
		}
	};

	const getPopularProducts = async () => {
		setPopularLoading(true);
		try {
			await get(`/api/popular-product-list/${customerDetails?.tenantId}`, true)
				.then((res) => {
					if (res.data.success) {
						setPopularProducts(res.data.records);
						setPopularOriginalData(res.data.records);
					} else {
						const errorMsg =
							res.data.errors?.map((error) => error).join(", ") || res.data.message;
						ErrorMessage("Products", errorMsg);
					}
					setPopularLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("Products", message);
					setPopularLoading(false);
				});
		} catch (error) {
			ErrorMessage("Products", "Something went wrong try again!!");
			setPopularLoading(false);
		}
	};

	const getRecentProducts = async () => {
		setRecentLoading(true);
		try {
			await get(`/api/recent-product-list/${customerDetails?.tenantId}`, true)
				.then((res) => {
					if (res.data.success) {
						setRecentProducts(res.data.records);
						setRecentOriginalData(res.data.records);
					} else {
						const errorMsg =
							res.data.errors?.map((error) => error).join(", ") || res.data.message;
						ErrorMessage("Products", errorMsg);
					}
					setRecentLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("Products", message);
					setRecentLoading(false);
				});
		} catch (error) {
			ErrorMessage("Products", "Something went wrong try again!!");
			setRecentLoading(false);
		}
	};

	const extractData = (products) => {
		const productList = products?.map((product) => {
			return [
				prepareTitle(product),
				`$${product?.price ?? "NA"} / ${product?.TermDuration}`,
				`$${product?.RRP ?? "NA"} / ${product?.TermDuration}`,
				inputQty(product),
				ADD_BTN(product),
			];
		});
		return productList;
	};

	const inputQty = (product) => {
		return (
			<CustomInput
				inputProps={{
					id: `qty_${product?.ProductId}`,
					type: "number",
					placeholder: "Enter your quantity here",
					defaultValue: 1,
				}}
				formControlProps={{
					fullWidth: false,
					className: classes2.formControl,
				}}
			/>
		);
	};

	const prepareTitle = (product) => {
		return (
			<>
				<div className={classesCSStyles?.labelAc}>
					<h4>{product.Description}</h4>
				</div>
				<div>
					STOCK CODE: <span>{product.Stockcode}</span>
				</div>
			</>
		);
	};

	const ADD_BTN = (product) =>
		[
			{ color: "info", text: <Add className={classesCSStyles?.buttonIcon} /> },
		].map((prop, key) => {
			return (
				// <Button
				// 	size="sm"
				// 	disabled={loading}
				// 	justIcon
				// 	color={prop.color}
				// 	key={key}
				// 	className={classNames(classesCSStyles?.mx5)}
				// 	onClick={() => addProductToCart(product)}>
				// 	{prop.text}
				// </Button>
				<button
					key={key}
					disabled={loading}
					className={classNames(
						classesCSStyles?.buttonPrimary,
						classesCSStyles?.mx5
					)}
					onClick={() => addProductToCart(product)}>
					{prop.text}
				</button>
			);
		});

	async function addProductToCart(product) {
		const qtyInput = document.getElementById(`qty_${product?.ProductId}`);
		const qty = qtyInput.value;
		if (qty <= 0) {
			ErrorMessage("Add to Cart", "Please enter valid quantity");
			return;
		}

		if (!qty) {
			ErrorMessage("Add to Cart", "Please enter quantity");
			return;
		}
		setLoading(true);
		LoadingMgs("Add to Cart", "processing...");
		const formField = {
			product_id: product?.bcno,
			quantity: qty,
		};
		try {
			await post(`/api/cart/add/${customerDetails?.tenantId}`, formField, true)
				.then((res) => {
					if (res.data.success) {
						SuccessMessage("Add to Cart", res.data.message);
						dispatch(setCart(res.data.records));
						window.scrollTo(0, 0);
						document.body.scrollTop = 0;
						qtyInput.value = 1;
						getCartsDetails();
					} else {
						ErrorMessage("Add to Cart", res.data.message);
					}
					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("Add to Cart", message);
					setLoading(false);
				});
		} catch (error) {
			ErrorMessage("Add to Cart", "Something went wrong try again!!");
			setLoading(false);
		}
	}

	const getCartsDetails = async () => {
		setLoading(true);
		try {
			await get(`/api/cart/list/${customerDetails?.tenantId}`, true)
				.then((res) => {
					if (res.data.success) {
						dispatch(setCart(res.data.records));
					} else {
						const errorMsg =
							res.data.errors?.map((error) => error).join(", ") || res.data.message;
						console.log(errorMsg, "errorMsg");
						ErrorMessage("Products", errorMsg);
					}
					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("Products", message);
					setLoading(false);
				});
		} catch (error) {
			ErrorMessage("Products", "Something went wrong try again!!");
			setLoading(false);
		}
	};

	const handleSearch = (e) => {
		setSearchText(e.target.value);
		manageProductSearch(e.target.value);
	};

	const manageProductSearch = (value) => {
		const searchTerm = value.trim().toLowerCase();

		// Keyword aliasing (add more if needed)
		const keywordMap = {
			standard: ["standard", "std"],
			std: ["standard", "std"],
			sta: ["standard", "std"],
			stan: ["standard", "std"],
			stand: ["standard", "std"],
			standa: ["standard", "std"],
			standar: ["standard", "std"],
		};

		// Get aliases or fallback to just the search term itself
		const searchKeywords = keywordMap[searchTerm] || [searchTerm];

		if (searchTerm.length > 0) {
			const filteredData = originalData?.filter((product) => {
				const description = (product?.Description || "").toLowerCase();
				// Check if any of the keywords are present in the description
				return searchKeywords.some((keyword) => description.includes(keyword));
			});
			setProducts(filteredData);

			//do it for recent products
			const filteredRecentData = recentProducts?.filter((product) => {
				const description = (product?.Description || "").toLowerCase();
				// Check if any of the keywords are present in the description
				return searchKeywords.some((keyword) => description.includes(keyword));
			});
			setRecentProducts(filteredRecentData);

			//do it for popular products
			const filteredPopularData = popularProducts?.filter((product) => {
				const description = (product?.Description || "").toLowerCase();
				// Check if any of the keywords are present in the description
				return searchKeywords.some((keyword) => description.includes(keyword));
			});
			setPopularProducts(filteredPopularData);
		} else {
			setProducts(originalData);
			setRecentProducts(recentOriginalData);
			setPopularProducts(popularOriginalData);
		}
	};

	const handleClear = () => {
		document.getElementById("search").value = "";
		manageProductSearch("");
	};

	const cancelOrder = () => {
		dispatch(
			setDashboard({
				OrderSummary: false,
				ConfirmOrder: false,
				Heading: "Microsoft 365",
				TeamT5Form: false,
				KinetixForm: false,
				CustomerSubscriptionDetails: true,
				AddCustomerSubscription: false,
				selectedDialogData: null,
			})
		);
	};

	return (
		<div className={classesCSStyles.mx5}>
			<Card className={classNames(classesCSStyles.px5, classesCSStyles.minHeight)}>
				<CardHeader color="info" className="">
					<GridContainer>
						<GridItem xs={12} sm={6} md={6}>
							<h4 className={classesCSStyles?.cartLabel}>Add Products</h4>
						</GridItem>
					</GridContainer>
				</CardHeader>
				<CardBody
					className={classNames(
						classesCSStyles.accountSection,
						classesCSStyles.my10
					)}>
					<GridContainer className={classNames(classesCSStyles.marginAuto)}>
						<GridItem
							xs={12}
							sm={9}
							md={9}
							className={classNames(
								classesCSStyles.rightSideBorder,
								loading ? classesCSStyles.loading : ""
							)}>
							<GridContainer>
								<GridItem xs={12} sm={6} md={6}>
									<h4
										className={classNames(
											classesCSStyles?.titleProducts,
											classesCSStyles?.py5,
											classesCSStyles?.mT20
										)}>
										Popular Products
									</h4>
								</GridItem>
								<GridItem xs={12} sm={6} md={6}>
									{popularLoading && (
										<Loading width={30} height={30} className="text-center" />
									)}
									<div
										className={classNames(
											classesCSStyles?.py5,
											classesCSStyles?.mT,
											classesCSStyles?.alignRight
										)}>
										<div
											className={classNames(
												classesCSStyles.searchWrapper,
												classesCSStyles?.width30,
												classes2.mlAuto,
												classesCSStyles?.mL
											)}>
											<input
												type="text"
												id="search"
												placeholder="Search Products"
												className={classNames(classesCSStyles.searchInput)}
												onChange={(e) => {
													handleSearch(e);
												}}
											/>
											<div className={classNames(classesCSStyles.clearIcon)}>
												<span
													className={classNames(classesCSStyles.clearIcon)}
													onClick={() => {
														handleClear();
													}}>
													x
												</span>
											</div>
										</div>
									</div>
								</GridItem>
							</GridContainer>
							<GridContainer>
								{popularProducts?.map((product, index) => {
									return (
										<GridItem xs={12} sm={6} md={6} key={index}>
											<CoreCard className={classes3.card}>
												<CardContent className={classes3.content}>
													<GridContainer>
														<GridItem
															xs={12}
															sm={12}
															md={12}
															style={{
																backgroundColor: product?.button_colour,
																color: "#313131FF",
															}}
															className={classNames(
																classesCSStyles?.py5,
																classesCSStyles?.bottomBorder
															)}>
															{prepareTitle(product)}
														</GridItem>
														<GridItem xs={12} sm={3} md={3} className={classesCSStyles?.py2}>
															${product?.price ?? "NA"} / {product?.TermDuration}
														</GridItem>
														<GridItem xs={12} sm={3} md={3} className={classesCSStyles?.py2}>
															${product?.RRP ?? "NA"} / {product?.TermDuration}
														</GridItem>
														<GridItem xs={12} sm={2} md={2}></GridItem>
														<GridItem
															xs={12}
															sm={4}
															md={4}
															className={classNames("flex", classesCSStyles?.rightAlign)}>
															{inputQty(product)}
															{ADD_BTN(product)}
														</GridItem>
													</GridContainer>
												</CardContent>
											</CoreCard>
										</GridItem>
									);
								})}
								{!popularLoading &&
									(popularProducts.length === 0 || popularProducts?.length === 0) && (
										<div
											className={classNames(classesCSStyles?.px5, classesCSStyles?.mx5)}>
											No popular products Available. Please try again later.
										</div>
									)}

								<GridItem
									xs={12}
									sm={12}
									md={12}
									className={classNames(
										classesCSStyles?.my10,
										classesCSStyles?.topBorder
									)}>
									<h4 className={classNames(classesCSStyles?.titleProducts)}>
										Recent Products
									</h4>
								</GridItem>
								<GridItem xs={12} sm={12} md={12}>
									<Table
										striped
										tableHead={["DESCRIPTION", "PRICE", "RRP", "QTY", "ACTION"]}
										tableData={extractData(recentProducts)}
										customCellClasses={[
											classes.textLeft,
											classes.textLeft,
											classes.textLeft,
											classes.textLeft,
											classes.textLeft,
										]}
										customClassesForCells={[0, 1, 2, 3, 4]}
										customHeadCellClasses={[
											classNames(
												classes.textLeft,
												classesCSStyles?.labelAc,
												classesCSStyles?.tableHeaderCell
											),
											classNames(
												classes.textLeft,
												classesCSStyles?.labelAc,
												classesCSStyles?.tableHeaderCell
											),
											classNames(
												classes.textLeft,
												classesCSStyles?.labelAc,
												classesCSStyles?.tableHeaderCell
											),
											classNames(
												classes.textLeft,
												classesCSStyles?.labelAc,
												classesCSStyles?.tableHeaderCell
											),
											classNames(
												classes.textLeft,
												classesCSStyles?.labelAc,
												classesCSStyles?.tableHeaderCell
											),
										]}
										customHeadClassesForCells={[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}
									/>
									{recentLoading && (
										<Loading width={30} height={30} className="text-center" />
									)}
									{!recentLoading &&
										(recentProducts.length === 0 || recentProducts?.length === 0) && (
											<div className={classNames(classesCSStyles?.my10)}>
												No Recent Products Available. Please try again later.
											</div>
										)}
								</GridItem>
							</GridContainer>
							<GridContainer>
								<GridItem xs={12} sm={6} md={6}>
									<h4
										className={classNames(
											classesCSStyles?.titleProducts,
											classesCSStyles?.py5,
											classesCSStyles?.mT20
										)}>
										All Products
									</h4>
								</GridItem>
								{/* <GridItem xs={12} sm={6} md={6}>
									<div
										className={classNames(
											classesCSStyles?.py5,
											classesCSStyles?.mT,
											classesCSStyles?.alignRight
										)}>
										<div
											className={classNames(
												classesCSStyles.searchWrapper,
												classesCSStyles?.width30,
												classes2.mlAuto,
												classesCSStyles?.mL
											)}>
											<input
												type="text"
												id="search"
												placeholder="Search Products"
												className={classNames(classesCSStyles.searchInput)}
												onChange={(e) => {
													handleSearch(e);
												}}
											/>
											<div className={classNames(classesCSStyles.clearIcon)}>
												<span
													className={classNames(classesCSStyles.clearIcon)}
													onClick={() => {
														handleClear();
													}}>
													x
												</span>
											</div>
										</div>
									</div>
								</GridItem> */}
							</GridContainer>

							<div
								className={classNames(
									classesCSStyles?.topBorder,
									classesCSStyles?.mT20,
									"flex"
								)}></div>
							<Table
								striped
								tableHead={["DESCRIPTION", "PRICE", "RRP", "QTY", "ACTION"]}
								tableData={extractData(products)}
								customCellClasses={[
									classes.textLeft,
									classes.textLeft,
									classes.textLeft,
									classes.textLeft,
									classes.textLeft,
								]}
								customClassesForCells={[0, 1, 2, 3, 4]}
								customHeadCellClasses={[
									classNames(
										classes.textLeft,
										classesCSStyles?.labelAc,
										classesCSStyles?.tableHeaderCell
									),
									classNames(
										classes.textLeft,
										classesCSStyles?.labelAc,
										classesCSStyles?.tableHeaderCell
									),
									classNames(
										classes.textLeft,
										classesCSStyles?.labelAc,
										classesCSStyles?.tableHeaderCell
									),
									classNames(
										classes.textLeft,
										classesCSStyles?.labelAc,
										classesCSStyles?.tableHeaderCell
									),
									classNames(
										classes.textLeft,
										classesCSStyles?.labelAc,
										classesCSStyles?.tableHeaderCell
									),
								]}
								customHeadClassesForCells={[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}
							/>
							{loading && <Loading width={30} height={30} className="text-center" />}
							{!loading && (products.length === 0 || products?.length === 0) && (
								<div className={classNames(classesCSStyles?.my10)}>
									No Products Available. Please try again later.
								</div>
							)}
						</GridItem>
						<GridItem xs={12} sm={3} md={3}>
							<div className={classNames(classesCSStyles?.alignRight)}>
								<Cart />
							</div>
						</GridItem>
					</GridContainer>
				</CardBody>
			</Card>
		</div>
	);
};

export default SubscriptionAdd;
